module.exports = __webpack_public_path__ + "beauty.247d2ae8.png";